@if (!showProfiles) {
  <div class="mobile-menu">
    @if (items.length) {
      <div class="mobile-menu-list">
        @for (menuItem of items; track menuItem) {
          <a class="menu-link" [routerLink]="menuItem.link" (click)="closeMobileMenu.emit(menuItem)">{{
            menuItem.label
          }}</a>
        }
      </div>
    }
    <div class="menu-link" (click)="showProfiles = true">Profile</div>
    <div class="menu-link" (click)="logout.emit()" data-id="logout-btn">Log out</div>
  </div>
}
@if (showProfiles) {
  <cm-user-profiles-list class="mobile-user-callout" [profile]="profile" [profiles]="profiles" />
}
